var buttonGroup = {
    base: {
        boxSizing: "content-box",
        border: "solid 1px",
        borderColor: "black.30",
        display: "grid",
        borderRadius: 3,
        gridAutoFlow: "column",
        "--button-group--padding": "6px",
        p: "var(--button-group--padding)",
        boxShadow: "inset 0px 1px 2px rgba(153, 153, 153, 0.2), inset 0px 2px 4px rgba(153, 153, 153, 0.2)",
    },
    variants: {
        size: {
            xs: {
                "--button-group-height": "24px",
            },
            sm: {
                "--button-group-height": "32px",
            },
            md: {
                "--button-group-height": "44px",
            },
            lg: {
                "--button-group-height": "56px",
            },
            inherit: {
                fontSize: "inherit",
                fontWeight: "inherit",
                "--button-height": "100%",
                width: ["100%", "100%"],
                padding: 0,
                justifyContent: "center",
            },
        },
        rounded: {
            true: {
                borderRadius: "calc((var(--button-group-height) + var(--button-group--padding))/2)", // add padding to border radius
            },
        },
    },
};

export { buttonGroup };
//# sourceMappingURL=button-group.js.map
